import { render, staticRenderFns } from "./myProfile.vue?vue&type=template&id=6f40e3a4&scoped=true"
import script from "./myProfile.vue?vue&type=script&lang=js"
export * from "./myProfile.vue?vue&type=script&lang=js"
import style0 from "./myProfile.vue?vue&type=style&index=0&id=6f40e3a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f40e3a4",
  null
  
)

export default component.exports